import React from 'react';
import { Monitor } from 'lucide-react';

/**
 * CanvasMobileGate — gates the workflow canvas on small screens.
 *
 * The canvas is an inherently desktop drag-and-drop editor (ReactFlow pan/zoom).
 * Below the lg breakpoint (<1024px) it shows a short interstitial instead of an
 * unusable surface; at lg+ it renders the canvas unchanged. Everything else in the
 * console is responsive, so only this one route is gated.
 */
export default function CanvasMobileGate({ children }) {
  const [small, setSmall] = React.useState(
    () => typeof window !== 'undefined' && !!window.matchMedia
      && window.matchMedia('(max-width: 1023px)').matches
  );
  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia('(max-width: 1023px)');
    const onChange = () => setSmall(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  if (!small) return children;

  return (
    <div className="min-h-full bg-v2-page text-v2-ink flex items-center justify-center p-8">
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-v2-muted flex items-center justify-center text-v2-ink-muted">
          <Monitor size={22} aria-hidden="true" />
        </div>
        <h1 className="text-[18px] font-bold text-v2-ink mb-1.5">
          Open the workflow canvas on a larger screen
        </h1>
        <p className="text-[13px] text-v2-ink-secondary leading-relaxed">
          The visual workflow editor needs a wider viewport for drag-and-drop. Switch to a
          desktop, or widen this window, to design workflows. Everything else in the console
          works on mobile.
        </p>
      </div>
    </div>
  );
}
